module.exports = __webpack_public_path__ + "img/json.0a2e0ed5.svg";